import { WifiOff } from 'lucide-react';

import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';

export function NetworkStatusBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div
      role="alert"
      aria-live="assertive"
      className="flex items-center gap-2 border-b border-yellow-200 bg-yellow-50 px-4 py-2 text-sm text-yellow-800"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>You&apos;re offline. Recordings will be saved and uploaded when you reconnect.</span>
    </div>
  );
}
